import { z } from 'zod';

export const loginEmailSchema = z.object({
  email: z.email({ message: 'Please enter a valid email address' }),
});

export type LoginEmailFormValues = z.infer<typeof loginEmailSchema>;
